// export const SUBMIT_USER_ROLE = 'SUBMIT_USER_ROLE';
import commonUtil from '../../../../utils/commonUtil';

export const GIFT_REGISTRY_CELEBRATED_LOAD = 'GIFT_REGISTRY_CELEBRATED_LOAD';
export const GIFT_REGISTRY_CELEBRATED_LOAD_SUCCESS = 'GIFT_REGISTRY_CELEBRATED_LOAD_SUCCESS';
export const GIFT_REGISTRY_CELEBRATED_LOAD_FAIL = 'GIFT_REGISTRY_CELEBRATED_LOAD_FAIL';

export function isGiftRegistryCelebratedLoaded(globalState) {
  return globalState.SelectTypeEvent && globalState.SelectTypeEvent.loaded;
}

export function loadGiftRegistryCelebrated(emailId, eventType) {
  const _coOwnerEligibility = {};
  _coOwnerEligibility.brand = commonUtil.getBrand();
  _coOwnerEligibility.channel = commonUtil.getChannel().toUpperCase();
  _coOwnerEligibility.emailId = emailId;
  _coOwnerEligibility.eventType = eventType || '';
  return commonUtil.triggerServerRequest({ url: '/api/isCoOwnerEligible', method: 'POST', data: _coOwnerEligibility });
}
// export const handleSubmitUserRole = payload => ({
//   type: SUBMIT_USER_ROLE,
//   data: payload,
// });
